"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _reselect = require("reselect");

var _PropertyTypes = _interopRequireDefault(require("redux-less/constants/PropertyTypes"));

var _getNumberOfNestedPropertyChanges = _interopRequireDefault(require("./getNumberOfNestedPropertyChanges"));

var _isPropertyChanged = _interopRequireDefault(require("./isPropertyChanged"));

var _isOrderedMapPropertyChanged = _interopRequireDefault(require("./isOrderedMapPropertyChanged"));

var _default = function _default(_ref) {
  var properties = _ref.properties,
      currentSelector = _ref.currentSelector,
      nextSelector = _ref.nextSelector;
  return (0, _reselect.createSelector)([currentSelector, nextSelector], function (current, next) {
    if (current) {
      var changes = 0;
      properties.forEach(function (property) {
        if (typeof property === "string" && (0, _isPropertyChanged.default)(current.get(property), next.get(property))) {
          changes += 1;
        } else if ((0, _typeof2.default)(property) === "object" && property.type) {
          if (property.type === _PropertyTypes.default.SIMPLE && (0, _isPropertyChanged.default)(current.get(property.key), next.get(property.key))) {
            changes += 1;
          } else if (property.type === _PropertyTypes.default.ORDERED_MAP && (0, _isOrderedMapPropertyChanged.default)({
            current: current.get(property.key),
            next: next.get(property.key)
          })) {
            changes += 1;
          } else if (property.type === _PropertyTypes.default.NESTED) {
            changes += (0, _getNumberOfNestedPropertyChanges.default)({
              property: property,
              currentValue: current.get(property.key),
              nextValue: next.get(property.key)
            });
          }
        }
      });
      return changes;
    }

    return 0;
  });
};

exports.default = _default;
module.exports = exports.default;